export default __webpack_public_path__ + "static/media/mobile-active.3135a9ce.svg";